import routes from '@/modules/setting/setting-routes';
import store from '@/modules/setting/setting-store';
// import OfferAutocompleteInput from '@/modules/offer/components/offer-autocomplete-input';

export default {
  // components: [OfferAutocompleteInput],
  routes,
  store,
};
